import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSiderTitle from '../../../../components/newsSiderTitle';
import NewsSiderContent from '../../../../components/newsSiderContent';

class FictionList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { nav, data },
        } = this.props;

        return (
            <div>
                <NewsSiderTitle type={1} content={nav} />
                <NewsSiderContent content={data} />
            </div>
        );
    }
}

export default errorBoundary(FictionList);
